(function () {
  'use strict';
  angular.module('ringbaPortal').controller('OAuthController', OAuthController);

  function OAuthController(
    $state,
    authService,
    cacheService,
    oAuth
  ) {
    'ngInject';

    const vm = this;

    vm.$state = $state;
    vm.authService = authService;
    vm.cacheService = cacheService;
    vm.$onInit = onInit;
    vm.oAuth = oAuth;

    function onInit() {
      refreshTokenAndSendToParent();
    }

    async function refreshTokenAndSendToParent() {
      // Forces a new token
      await vm.authService.refreshToken();
      const authData = vm.cacheService.get('authService.authorizationData');

      if (!isInsideIframe()) {
        vm.$state.go('login');
      }

      sendTokenToParent(authData);
    }

    // Check if the controller is inside an Iframe to avoid accessing this from the window.
    function isInsideIframe() {
      return (window.self.name === 'ringbaAuthPopupWindow' && Boolean(window.opener));
    }

    function sendTokenToParent(refreshToken) {      
      if (refreshToken) {
        window.opener.postMessage(refreshToken, vm.oAuth.zendeskOAuthIframeTarget);
      }
    }

  }
})();

